import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import React from "react";
import "./MessageBox.css";
import { Typography } from "@mui/material";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface MessageBoxProps {
    header: string | React.ReactNode;
    message?: string | React.ReactNode;
    type: MessageBoxType;
    style?: React.CSSProperties;
}
const MessageBox = React.forwardRef(({ header, message, type, style }: MessageBoxProps, ref) => {
    const styles: MessageBoxStyles = {
        information: {
            icon: MirageTheme.icons.infoIcon,
            color: MirageTheme.palette.primary.main,
        },
        warning: {
            icon: MirageTheme.icons.warningIcon,
            color: MirageTheme.palette.warning.main,
        },
        error: {
            icon: MirageTheme.icons.warningIcon,
            color: MirageTheme.palette.error.main,
        },
    };
    const color = styles[type].color;

    return (
        <blockquote style={{ ...style, borderColor: color }} className="messageBox" ref={ref as any}>
            <Typography className="messageBox__header" component={"div"}>
                <FontAwesomeIcon icon={styles[type].icon} color={color} style={{ ...MirageTheme.icons.sizeS, marginRight: "0.5rem" }} />
                {header}
            </Typography>
            <Typography variant="subtitle2">{message}</Typography>
        </blockquote>
    );
});

type MessageBoxType = "information" | "warning" | "error";

type MessageBoxStyles = {
    [x in MessageBoxType]: {
        icon: IconDefinition;
        color: string;
    };
};

export default MessageBox;
